import React from 'react';
import { observer, inject } from 'mobx-react';

import { Nullable } from 'chaika-frontend-types/frontend-cms';

import { scrollPageContentHOC, WithScrollPageContentProps } from '@hoc/scrollPageContentHOC';

import { RightContent, RightContentProps } from './RightContent';
import { EntryPage as EntryPageStore, PageMode } from '@patient/ui/shared/store';
import { EntryVersion } from '../EntryVersion';
import { translate } from '@chaika/i18n/helper';

interface Props extends RightContentProps {}

interface WithHOCProps extends Props, WithScrollPageContentProps {}

interface StoreProps {
    entryPage: EntryPageStore;
}

@observer
class RightContentContainer extends React.Component<WithHOCProps & StoreProps> {
    public render(): React.ReactNode {
        const { onScroll, onWheel, onCloseClick } = this.props;
        const title = this.getTitle();
        const children = this.getChildren();

        return React.createElement(RightContent, {
            title,
            children,
            onWheel,
            onScroll,
            onCloseClick,
            onClickOutsideRightContent: this.props.entryPage.onClickOutsideRightContent ?? undefined,
        });
    }

    private getTitle(): string {
        const {
            entryPage: { pageMode },
        } = this.props;

        switch (pageMode) {
            case PageMode.History:
                return translate('history');
            case PageMode.Version:
                return translate('versions');
            default:
                return translate('versions');
        }
    }

    private getChildren(): Nullable<React.JSX.Element> {
        const {
            entryPage: { pageMode },
        } = this.props;

        // eslint-disable-next-line sonarjs/no-all-duplicated-branches
        switch (pageMode) {
            case PageMode.Version:
                return React.createElement(EntryVersion);
            default:
                return React.createElement(EntryVersion);
        }
    }
}

export const withHOCRightContentContainer = inject<Props, StoreProps>(EntryPageStore.Name)(
    scrollPageContentHOC<Props>(RightContentContainer),
);
